import { render } from "./WorkHistory.vue?vue&type=template&id=5a21895e"
import script from "./WorkHistory.vue?vue&type=script&lang=js"
export * from "./WorkHistory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__